import type { Brand } from "@pdfking/tfunc"

export type PageNumber = Brand<number, "PageNumber">
